"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useAddItemStyles = () => {
    const theme = (0, material_1.useTheme)();
    const paidCheckIcon = {
        padding: '7px',
        color: 'white',
        borderRadius: '100%',
        width: '2rem',
        height: '2rem',
        backgroundColor: theme.palette.primary.main,
        fontWeight: '100',
        cursor: 'pointer',
    };
    const paidPlusIcon = {
        padding: '5px',
        color: theme.palette.grey[700],
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: '100%',
        width: '2rem',
        height: '2rem',
        backgroundColor: 'white',
        fontWeight: '100',
        cursor: 'pointer',
    };
    return {
        paidCheckIcon,
        paidPlusIcon,
    };
};
exports.default = useAddItemStyles;
